import { upgrade } from '../reducer/upgrade';

const upgradeActions = { ...upgrade.actions };

export default upgradeActions;
